import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const BASE_URL = process.env.API_URL + '/admin'

const HomepageBannerService = {
  actions: {
    fetchAllHomepageBanners ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banners',
          method: 'GET'
        })
          .then(resp => {
            const homepageBanners = resp.data.homepageBanners
            commit('api_success')
            resolve(resp)
            return homepageBanners
          })
          .catch(err => {
            dispatch('catchHandler')
            reject(err)
          })
      })
    },
    createHomepageBanner ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banner',
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    deleteHomepageBanner ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banner/' + id,
          method: 'delete'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    editHomepageBanner ({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banner/' + data.get('id'),
          data: data,
          method: 'POST'
        })
          .then(resp => {
            commit('api_success')
            resolve(resp)
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    },
    fetchHomepageBanner ({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('api_request')
        axios({
          url: BASE_URL + '/homepage-banner/' + id,
          method: 'GET'
        })
          .then(resp => {
            const homepageBanner = resp.data.homepageBanner
            commit('api_success')
            resolve(resp)
            return homepageBanner
          })
          .catch(err => {
            commit('api_error')
            reject(err)
          })
      })
    }
  }
}

export default HomepageBannerService



// WEBPACK FOOTER //
// ./src/services/homepageBannerService.js